<div [ngClass]="{'openMission': openMission}" class="mb-5">
  <!-- <div class="row justify-content-end align-items-center bg-light fixed-bottom"> -->
  <nb-card>
    <nb-card-body>
      <div class="d-flex justify-content-between align-items-center">
        <div class="start d-flex align-items-center">
          <h2 class="mb-0">{{ editedMission?.name | txtTranslate }}</h2>
          <button *ngIf="!openMission" nbButton size="medium" ghost status="danger" class="btn ml-3"
            (click)="deleteMission($event, editedMission)">
            <nb-icon icon="trash"></nb-icon>
          </button>

        </div>
        <div class="end d-flex align-items-center justify-content-end">
          <nb-select [(selected)]="languageService.currentLang">
            <nb-option *ngFor="let lang of languages" [value]="lang">{{ languageService.getLang(lang)?.name }}
            </nb-option>
          </nb-select>
          <button *ngIf="!openMission" nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="getPreviewPath()"><!-- (click)="openPreview()"-->
            <nb-icon icon="eye-outline" pack="eva"></nb-icon> Preview
          </button>
          <button *ngIf="openMission" nbButton size="tiny" status="basic" class="btn ml-3" (click)="getPreviewViewMission()">
            <nb-icon icon="eye-outline" pack="eva"></nb-icon> Preview
          </button>
          <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="game?.id || _template?.id"
            (click)="duplicateMission($event)">
            <nb-icon icon="copy"></nb-icon> Copy mission
          </button>

          <button *ngIf="!openMission" nbButton size="tiny" status="success" class="btn ml-3" 
            [disabled]="!isMissionValid()" (click)="onSubmit()">
            <nb-icon icon="save-outline" pack="eva"></nb-icon> Save
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
  <nb-card class="sticky-top">
    <nb-card-body class="params-titles">
      <div class="row col-auto d-flex justify-content-between align-items-center sticky-top">
        <div class="col-12 row">
        <!--TEMPLATE INFO-->
        <div *ngIf="game?.id && _template?.id" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="template" [(ngModel)]="checkedAtt['0']">
          <label class="text" [ngClass]="{'selected': checkedAtt['0']}" (click)="loadDetailParam($event, 'T', '0')">Template</label>
        </div>
        <span *ngIf="game?.id && _template?.id" class="vertical-line"></span>
        <!--/TEMPLATE INFO-->

        <!-- DETAILS -->
        <div class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="generalities" [(ngModel)]="checkedAtt['1']">
          <label class="text" [ngClass]="{'selected': checkedAtt['1']}" (click)="loadDetailParam($event, 'MG', '1')">Generalities</label>
        </div>
        <span  class="vertical-line"></span>

        <!-- /DETAILS -->
  
        <!-- LOCATION -->
        <div *ngIf="!openMission && missionForm.value.geographic" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="location" [(ngModel)]="checkedAtt['2']">
          <label class="text" [ngClass]="{'selected': checkedAtt['2']}" (click)="loadDetailParam($event, 'ML', '2')">Location</label>
        </div>
        <span *ngIf="!openMission && missionForm.value.geographic" class="vertical-line"></span>
        <!-- /LOCATION -->
  
        <!-- UNLOCKED -->
        <div class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="unlocked" [(ngModel)]="checkedAtt['3']">
          <label class="text" [ngClass]="{'selected': checkedAtt['3']}" (click)="loadDetailParam($event, 'MU', '3')">Unlocked</label>
        </div>
        <span class="vertical-line"></span>
        <!-- /UNLOCKED -->
  
        <!-- DEPENDENCIES -->
        <div *ngIf="!openMission && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="dependencies" [(ngModel)]="checkedAtt['4']">
          <label class="text" [ngClass]="{'selected': checkedAtt['4']}" (click)="loadDetailParam($event, 'MD', '4')">Dependencies</label>
        </div>
        <span *ngIf="!openMission && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'" class="vertical-line"></span>
        <!-- /DEPENDENCIES -->
  
        <!-- FORBIDDEN ZONE-->
        <div *ngIf="!openMission && missionForm.value.type == 'FZONE'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="forbidden-zone-details" [(ngModel)]="checkedAtt['5']">
          <label class="text" [ngClass]="{'selected': checkedAtt['5']}" (click)="loadDetailParam($event, 'FZONE', '5')">Forbidden zone details</label>
        </div>
        <span *ngIf="!openMission && missionForm.value.type == 'FZONE'" class="vertical-line"></span>
  
        <!-- REWARD -->
        <div *ngIf="missionForm.value.type == 'REWARD'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="reward" [(ngModel)]="checkedAtt['6']">
          <label class="text" [ngClass]="{'selected': checkedAtt['6']}" (click)="loadDetailParam($event, 'REWARD', '6')">Reward</label>
        </div>
        <span *ngIf="missionForm.value.type == 'REWARD'" class="vertical-line"></span>
        <!-- /REWARD -->
  
        <!--EXTERNAL GAME/URL-->
        <div class="accordion-params"
        *ngIf="missionForm.value.type == 'REWARD' && (missionForm.value.rewardMode == 'AUTO' || missionForm.value.rewardMode == 'RIDDLE' || missionForm.value.rewardMode == 'REACH')">
          <input class="checkbox-attribute" type="checkbox" id="external-game-link" [(ngModel)]="checkedAtt['7']">
          <label class="text" [ngClass]="{'selected': checkedAtt['7']}" (click)="loadDetailParam($event, 'EGL', '7')">External game/link</label>
        </div>
        <span *ngIf="missionForm.value.type == 'REWARD' && (missionForm.value.rewardMode == 'AUTO' || missionForm.value.rewardMode == 'RIDDLE' || missionForm.value.rewardMode == 'REACH')" class="vertical-line"></span>
  
        <!-- CLUES -->
        <div *ngIf="missionForm.value.type == 'REWARD'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="clues" [(ngModel)]="checkedAtt['8']">
          <label class="text" [ngClass]="{'selected': checkedAtt['8']}" (click)="loadDetailParam($event, 'CLUES', '8')">Clues</label>
        </div>
        <span *ngIf="missionForm.value.type == 'REWARD'" class="vertical-line"></span>
        <!-- /CLUES -->
  
        <!-- Fork selections -->
        <div *ngIf="missionForm.value.type == 'FORK'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="fork-selections" [(ngModel)]="checkedAtt['9']">
          <label class="text" [ngClass]="{'selected': checkedAtt['9']}" (click)="loadDetailParam($event, 'FS', '9')">Fork selections</label>
        </div>
        <span *ngIf="missionForm.value.type == 'FORK'" class="vertical-line"></span>
        <!-- /Fork selections -->
  
        <!-- Role assignment quizz -->
        <div *ngIf="missionForm.value.type == 'ROLASSIGN'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="fork-selections" [(ngModel)]="checkedAtt['13']">
          <label class="text" [ngClass]="{'selected': checkedAtt['13']}" (click)="loadDetailParam($event, 'RAQ', '13')">Role assignment quizz</label>
        </div>
        <span *ngIf="missionForm.value.type == 'ROLASSIGN'" class="vertical-line"></span>
        <!-- /Role assignment quizz -->
  
        <!-- Quizz -->
        <div *ngIf="missionForm.value.type == 'QUIZZ'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="fork-selections" [(ngModel)]="checkedAtt['15']">
          <label class="text" [ngClass]="{'selected': checkedAtt['15']}" (click)="loadDetailParam($event, 'QUIZZ', '15')">Quizz</label>
        </div>
        <span *ngIf="missionForm.value.type == 'QUIZZ'" class="vertical-line"></span>
        <!-- /Quizz -->
  
        <!-- Role reveal -->
        <div *ngIf="missionForm.value.type == 'ROLREVEAL'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="fork-selections" [(ngModel)]="checkedAtt['14']">
          <label class="text" [ngClass]="{'selected': checkedAtt['14']}" (click)="loadDetailParam($event, 'RRV', '14')">Role reveal</label>
        </div>
        <span *ngIf="missionForm.value.type == 'ROLREVEAL'" class="vertical-line"></span>
        <!-- /Role reveal -->
  
        <!-- Success -->
        <div *ngIf="missionForm.value.type !== 'POI'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="success" [(ngModel)]="checkedAtt['10']">
          <label class="text" [ngClass]="{'selected': checkedAtt['10']}" (click)="loadDetailParam($event, 'SUCCESS', '10')">Success</label>
        </div>
        <span *ngIf="missionForm.value.type !== 'POI'" class="vertical-line"></span>
        <!-- /Success -->
  
        <!-- Failed -->
        <div *ngIf="missionForm.value.type == 'REWARD' || missionForm.value.type == 'FZONE'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="failed" [(ngModel)]="checkedAtt['11']">
          <label class="text" [ngClass]="{'selected': checkedAtt['11']}" (click)="loadDetailParam($event, 'FAILED', '11')">Failed</label>
        </div>
        <span *ngIf="missionForm.value.type == 'REWARD' || missionForm.value.type == 'FZONE'" class="vertical-line"></span>
        <!-- /Failed -->
  
        <!-- Mission specific parameters -->
        <div *ngIf="roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="mission-specific-parameters" [(ngModel)]="checkedAtt['12']">
          <label class="text" [ngClass]="{'selected': checkedAtt['12']}" (click)="loadDetailParam($event, 'MSP', '12')">specific parameters</label>
        </div>
        <span *ngIf="missionForm.value.type !== 'POI'" class="vertical-line"></span>
        <!-- /Mission specific parameters -->

        <!-- B2B parameters -->
        <div *ngIf="!gameId && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'" class="accordion-params">
          <input class="checkbox-attribute" type="checkbox" id="b2b-parameters" [(ngModel)]="checkedAtt['13']">
          <label class="text" [ngClass]="{'selected': checkedAtt['13']}" (click)="loadDetailParam($event, 'B2B', '13')">B2B parameters</label>
        </div>
        <!-- /B2B parameters -->
      </div>
      </div>
    </nb-card-body>
  </nb-card>

  <form id="missionForm" [ngClass]="{'formOpenMission': openMission}" [formGroup]="missionForm"
    (keydown.enter)="$event.target.id != 'locationname' && $event.target.id != 'answer' && $event.target.id != 'riddleText'">
    <div class="row mb-5">
      <div class=" accordion-container col-12">
        
          <!--TEMPLATE INFO-->
        <nb-card *ngIf="missionParams['T'] && game?.id && _template?.id">
          <nb-card-header class="params-title">Template</nb-card-header>
          <nb-card-body>
            <div class="row">
              <div class="col-md">
                <div class="form-group">
                  <label for="theme">Copy from template mission</label>
                  <nb-select fullWidth filled status="primary" placeholder="Select template"
                    [(ngModel)]="templateMissionId" [ngModelOptions]="{standalone: true}">
                    <nb-option *ngFor="let mission of templateMissions" [value]="mission.id">{{mission.name | txtTranslate}}</nb-option>
                  </nb-select>
                </div>
              </div>
            </div>
            <button nbButton type="button" size="tiny" status="success" class="btn ml-3" (click)="copyFromTemplate()" [disabled]="copyingFromTemplate || !templateMissionId">
              <nb-icon icon="copy-outline" pack="eva"></nb-icon> Copy mission data
            </button>
          </nb-card-body>
        </nb-card>
          <!-- DETAILS -->
          <nb-card *ngIf="missionParams['MG']">
            <nb-card-header class="params-title">Mission generalities</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" *ngIf="editedMission">
                    <label for="missionname" class="block text-sm/6 font-medium text-cgray-900">Mission name</label>
                    <div class="mt-2">
                      <input id="missionname" class="form-control" placeholder="Mission name"
                        [(ngModel)]="editedMission.name[languageService.currentLang]" [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                  <div *ngIf="missionForm.value.type !== 'POI'">
                    <label for="type" class="block text-sm/6 font-medium text-cgray-900">Mission type</label>
                    <div class="mt-2">
                      <nb-select formControlName="type" fullWidth filled status="primary" (selectedChange)="typeChange()">
                        <nb-option value="REWARD">Reward/Clue</nb-option>
                        <nb-option value="FORK">Fork</nb-option>
                        <nb-option value="FZONE">Forbidden zone</nb-option>
                        @if (game?.hasBuildings) {
                          <nb-option value="BUILDING">Building zone</nb-option>
                        }
                        <nb-option value="ROLASSIGN" *ngIf="game?.hasRoles">Role assignment</nb-option>
                        <nb-option value="ROLREVEAL" *ngIf="game?.hasRoles">Role reveal</nb-option>
                        <nb-option value="QUIZZ">Quizz</nb-option>
                      </nb-select>
                    </div>
                  </div>

                  <!--BUILDING -->
                  <div class="mt-2" *ngIf="missionForm.value.type == 'BUILDING'">
                    <label for="buildingType" class="block text-sm/6 font-medium text-cgray-900">Building type</label>
                    <div class="mt-2">
                      <nb-select formControlName="buildingType" fullWidth filled status="primary">
                        <nb-option value="habitation">Habitation</nb-option>
                        <nb-option value="public_service">Public service</nb-option>
                        <nb-option value="energy_production">Energy production</nb-option>
                      </nb-select>
                    </div>
                  </div>
                  <!--/BUILDING -->

                </div>
                <div class="col-sm-6">
                  <div>
                    <div class="form-group">
                      <label for="name">Mission icon</label>
                      <div fxLayout="row wrap" class="row col-12">
                        <ng-template ngFor let-icon="$implicit" [ngForOf]="icons">
                          <img src="assets/images/markers/{{ icon }}" class="icon-type"
                            [ngClass]="missionForm.value.icon == icon ? 'icon-selected' : ''"
                            (click)="switchMissionIcon(icon)">
                        </ng-template>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="name">Or select custom icon</label>
                      <div fxLayout="row wrap">
                        <input type="file" name="custom_icon" accept="image/*" (change)="handleIconInputChange($event)">
                      </div>
                      <div fxLayout="column" fxLayoutAlign="start center">
                        <img [src]="customIcon" *ngIf="customIcon" class="custom-icon-type" />
                        <a (click)="resetIcon()" *ngIf="customIcon">Delete</a>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="iconWidth">Icon width</label>
                      <input type="number" class="form-control" placeholder="width"
                        [(ngModel)]="editedMission.iconWidth" [ngModelOptions]="{standalone: true}"
                        onwheel="return false;">
                    </div>
                    <div class="form-group">
                      <label for="iconHeight">Icon height</label>
                      <input type="number" class="form-control" placeholder="width"
                        [(ngModel)]="editedMission.iconHeight" [ngModelOptions]="{standalone: true}"
                        onwheel="return false;">
                    </div>
                    <div class="form-group" *ngIf="openMission">
                      <label for="comment">Comment</label>
                      <input type="text" class="form-control" placeholder="Comment" [(ngModel)]="editedMission.comment[languageService.currentLang]" [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                </div>

              </div>
              
              <div class="row">
                <div class="col-12 bg-white p-3">
                  <h6 class="text-lg font-bold mb-2">Description</h6>
                  <app-block-editor attribute="description" [model]="editedMission?.description"
                    [languages]="languages"
                    [game]="game" [template]="_template" [characters]="characters" 
                    (modelUpdate)="save({description: $event})"></app-block-editor>
                  <!--<richtxt-editor label="Description" [model]="editedMission?.description"></richtxt-editor>-->
                </div>
              </div>
              
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" style="text-align:center;" *ngIf="!_mission.id">
                    <h6>Please save new mission first</h6>
                  </div>
                  <div class="form-group" *ngIf="_mission.id">
                    <h6>Select a picture to add to gallery or use drag/drop</h6>
                    <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                      [progress]="progressMap['IMGen']" [imageUrl]="previewImage" (fileUpdated)="handleFileUpdated($event, 'IMG')"></image-uploader>
                  </div>
                </div>
                <div class="col-sm-6 my-3">
                  <div class="row">

                    <ng-template ngFor let-picture="$implicit" [ngForOf]="pictures">
                      <div *ngIf="!picture.isUnlocked" class="col-sm-6 text-center">
                        <div>
                          <a href="{{ picture.url }}" target="_blank">
                            <img [src]="picture.thumbFileURL ? picture.thumbFileURL : picture.url"
                              class="pic_thumb img-fluid rounded">
                          </a>
                        </div>
                        <button type="button" nbButton size="medium" ghost status="danger"
                          (click)="deletePicture(picture)">Delete</button>

                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="geographic">Is geographic</nb-toggle>
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="active">Is first mission</nb-toggle>
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="isFinalMission">Is final mission</nb-toggle>
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="optional">Is optional mission</nb-toggle>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="name">Audio description</label>
                    <audio-uploader [audioUrl]="editedMission?.audioUrl" [progress]="progressMap['audioPath']"
                      (fileUpdated)="audioUpdated($event, 'audioPath', 'audioUrl')"
                      (delete)="deleteAudio('audioPath', 'audioUrl')"></audio-uploader>
                  </div>

                  <div class="form-group">
                    <nb-toggle status="info" [(ngModel)]="editedMission.audioAutoplay" [ngModelOptions]="{standalone: true}">Autoplay active</nb-toggle>
                  </div>
  
                  <div class="form-group">
                    <nb-toggle status="info" [(ngModel)]="editedMission.audioLoop" [ngModelOptions]="{standalone: true}">Loop active</nb-toggle>
                  </div>
                  
                </div>
              </div>

            </nb-card-body>
          </nb-card>
          <!-- /DETAILS -->

          <!-- LOCATION -->
          <nb-card *ngIf="missionParams['ML'] && missionForm.value.geographic">
            <nb-card-header class="params-title">Mission Location</nb-card-header>
            <nb-card-body  class="bg-light">
              <div class="row mb-3" *ngIf="gameId">
                <div class="col-sm-6">
                  <input id="locationname" class="form-control" placeholder="Location" formControlName="location"
                    (keyup.enter)="geocode($event)">
                  <div class="form-group d-none">
                    <input class="form-control" placeholder="Lat" formControlName="latitude">
                  </div>
                  <div class="form-group d-none">
                    <input class="form-control" placeholder="Lon" formControlName="longitude">
                  </div>
                </div>
                <div class="col-sm-6 d-flex justify-content-between">
                  <button type="button" nbButton size="medium" status="primary" (click)="geocode(null)">Find
                    location</button>
                  <button type="button" nbButton size="medium" ghost status="danger" (click)="clearLocation()">Clear
                    location</button>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-12">
                  <div>
                    <label for="placesSearchTerms">Google Places search terms (for deployment, use <b>;</b> separator)</label>
                    <input nbInput class="form-control" type="text" formControlName="placesSearchTerms">
                  </div>
                </div>
              </div>
              <div class="row mb-3" *ngIf="missionForm.value.type !== 'FZONE'">
                <div class="col-sm-6">
                  <nb-toggle status="info" formControlName="ignoreDistance">Ignore unlock distance</nb-toggle>
                </div>
                <div class="col-sm-6">
                  <div *ngIf="missionForm.value.ignoreDistance == false">
                    <label for="unlockDistance">Unlock distance (meters)</label>
                    <input nbInput class="form-control" type="number" formControlName="unlockDistance"
                      onwheel="return false;">
                  </div>
                </div>
              </div>
              <div class="row mb-3" *ngIf="missionForm.value.type !== 'FZONE'">
                <div class="col-sm-6">
                  <nb-toggle status="info" formControlName="ghost">Ghost mission</nb-toggle>
                </div>
                <div class="col-sm-6">
                  <nb-toggle status="info" formControlName="autoActivation">Activates when reached</nb-toggle>
                </div>
              </div>
              <div class="row" *ngIf="gameId">
                <div class="col-sm-12">
                  <google-map class="agm-map" height="500px" width="100%"
                    (mapInitialized)="mapReady($event)"
                    [options]="mapOptions" [center]="{lat: missionForm.value.latitude, lng: missionForm.value.longitude}">
                    @if (editedMission) {
                      <map-marker
                        [position]="{lat:missionForm.value.latitude, lng:missionForm.value.longitude}"
                        [icon]="{
                          url: customIcon ? customIcon : '/assets/images/markers/'+missionForm.value.icon,
                          scaledSize: !customIcon && missionForm.value.icon == icons[0] ? {
                            width:40,
                            height:40
                          } : {
                            width: editedMission.iconWidth,
                            height: editedMission.iconHeight
                          },
                          anchor: !customIcon && missionForm.value.icon == icons[0] ? {
                            x:20,
                            y:20
                          } : {
                            x:editedMission.iconWidth/2,
                            y:editedMission.iconHeight/2
                          }}" [options]="{draggable: true}" (mapDragend)="markerDragEnd($event)">
                      </map-marker>
                      @if(editedMission && missionForm.value.type !== 'FZONE' && !missionForm.value.ignoreDistance){
                        <map-circle
                          [center]="{lat:missionForm.value.latitude, lng:missionForm.value.longitude}"
                          [radius]="missionForm.value.unlockDistance"
                          [options]="{fillColor:'#FFAB00', fillOpacity:0.6, strokeOpacity:0}"></map-circle>
                      }
                      @if(editedMission && (missionForm.value.type == 'FZONE' || missionForm.value.type == 'BUILDING') && editedMission.zone?.type == 'circle'){
                        <map-circle
                          [center]="{lat:missionForm.value.latitude, lng:missionForm.value.longitude}"
                          [radius]="editedMission.zone.radius"
                          [options]="{fillColor:editedMission.zone.fillColor, fillOpacity:editedMission.zone.fillOpacity, strokeColor: editedMission.zone.strokeColor, strokeOpacity:editedMission.zone.strokeOpacity}"></map-circle>
                      }
                    }
                  </google-map>
                </div>
              </div>
              <div *ngIf="gameId && (missionForm.value.type == 'FZONE' || missionForm.value.type == 'BUILDING') && editedMission.zone">
                <div class="form-group d-flex flex-column flex-wrap" *ngIf="missionForm.value.type !== 'POI'">
                  <label for="type">Zone type</label>
                  <nb-select [(ngModel)]="editedMission.zone.type" [ngModelOptions]="{standalone: true}" fullWidth filled status="primary" (selectedChange)="zoneTypeChange()">
                    <nb-option value="circle">Circle</nb-option>
                    <nb-option value="polygon">Polygon</nb-option>
                  </nb-select>
                </div>
                <div class="form-group">
                  <label for="scol">Radius</label>
                  <input nbInput type="number" [(ngModel)]="editedMission.zone.radius" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="form-group">
                  <label for="scol">Stroke color</label>
                  <input nbInput type="color" [(ngModel)]="editedMission.zone.strokeColor" [ngModelOptions]="{standalone: true}" (change)="setPolygonOptions('strokeColor')">
                </div>
                <div class="form-group">
                  <label for="sop">Stroke opacity</label>
                  <input nbInput type="number" step="0.1" min="0" max="1" [(ngModel)]="editedMission.zone.strokeOpacity" [ngModelOptions]="{standalone: true}" (change)="setPolygonOptions('strokeOpacity')">
                </div>
                <div class="form-group">
                  <label for="swei">Stroke weight</label>
                  <input nbInput type="number" [(ngModel)]="editedMission.zone.strokeWeight" [ngModelOptions]="{standalone: true}" (change)="setPolygonOptions('strokeWeight')">
                </div>
                <div class="form-group">
                  <label for="fcol">Fill color</label>
                  <input nbInput type="color" [(ngModel)]="editedMission.zone.fillColor" [ngModelOptions]="{standalone: true}" (change)="setPolygonOptions('fillColor')">
                </div>
                <div class="form-group">
                  <label for="fop">Fill opacity</label>
                  <input nbInput type="number" step="0.1" min="0" max="1" [(ngModel)]="editedMission.zone.fillOpacity" [ngModelOptions]="{standalone: true}" (change)="setPolygonOptions('fillOpacity')">
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <label for="reward">Next geolocated missions</label>
                  <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                    [(ngModel)]="editedMission.geoDependencies" [ngModelOptions]="{standalone: true}">
                    <nb-option *ngFor="let mission of _missions" [value]="mission.id">
                      {{ mission.name | txtTranslate }}</nb-option>
                  </nb-select>
                </div>
              </div>
              
            </nb-card-body>
          </nb-card>
          <!-- /LOCATION -->

          <!-- UNLOCKED -->
          <nb-card *ngIf="missionParams['MU']">
            <nb-card-header class="params-title">Mission Unlocked</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="row border-bottom mb-5 pb-5">
                <div class="col-12">
                  <!--<richtxt-editor label="Unlocked description" [model]="editedMission?.unlockedDescription">
                  </richtxt-editor>-->
                  <div class="col-12 bg-white p-3">
                    <h6 class="text-lg font-bold mb-2">Unlocked description</h6>
                    <app-block-editor attribute="unlockedDescription" [model]="editedMission?.unlockedDescription"
                      [languages]="languages"
                      [game]="game" [template]="_template" [characters]="characters" 
                      (modelUpdate)="save({unlockedDescription: $event})"></app-block-editor>
                  </div>
                  <div class="form-group">
                    <label for="name">Unlocked audio description</label>
                    <audio-uploader [audioUrl]="editedMission?.unlockedAudioUrl"
                      [progress]="progressMap['unlockedAudioPath']"
                      (fileUpdated)="audioUpdated($event, 'unlockedAudioPath', 'unlockedAudioUrl')"
                      (delete)="deleteAudio('unlockedAudioPath', 'unlockedAudioUrl')"></audio-uploader>
                  </div>
                </div>
                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.unlockedAudioAutoplay" [ngModelOptions]="{standalone: true}">Autoplay active</nb-toggle>
                </div>

                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.unlockedAudioLoop" [ngModelOptions]="{standalone: true}">Loop active</nb-toggle>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" style="text-align:center;" *ngIf="!_mission.id">
                    <h6>Please save new mission first</h6>
                  </div>
                  <div class="form-group" *ngIf="_mission.id">
                    <h6>Select a picture to add to gallery or use drag/drop</h6>
                    <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                      [progress]="progressMap['UNLOCKEDen']" (fileUpdated)="handleFileUpdated($event, 'UNLOCKED')">
                    </image-uploader>
                  </div>
                </div>
                <div class="col-sm-6 my-3">
                  <div class="row">
                    <ng-template ngFor let-picture="$implicit" [ngForOf]="pictures">
                      <div *ngIf="picture.isUnlocked" class="col-sm-6 text-center">
                        <div>
                          <a href="{{ picture.url }}" target="_blank">
                            <img [src]="picture.url" class="pic_thumb img-fluid rounded">
                          </a>
                        </div>
                        <button type="button" nbButton size="medium" ghost status="danger"
                          (click)="deletePicture(picture)">Delete</button>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>

            </nb-card-body>
          </nb-card>
          <!-- /UNLOCKED -->

          <!-- DEPENDENCIES -->
          <nb-card *ngIf="missionParams['MD'] && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'">
            <nb-card-header class="params-title">Mission Dependencies</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="form-group">
                <label for="man-dependencies">Mandatory dependencies</label>
                <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select" [(ngModel)]="deps"
                  [ngModelOptions]="{standalone: true}">
                  <nb-option *ngFor="let mission of _missions" [value]="mission.id">{{ mission.name | txtTranslate }}
                  </nb-option>
                </nb-select>
              </div>
              <div class="form-group">
                <label for="opt-dependencies">Optional dependencies</label>
                <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                  [(ngModel)]="optionalDeps" [ngModelOptions]="{standalone: true}">
                  <nb-option *ngFor="let mission of _missions" [value]="mission.id">{{ mission.name | txtTranslate }}
                  </nb-option>
                </nb-select>
              </div>
              <div class="form-group">
                <label for="reward">Minimum validated deps required</label>
                <input nbInput class="form-control" type="number" formControlName="optionalDepRequiredNbr"
                  onwheel="return false;">
              </div>
            </nb-card-body>
          </nb-card>
          <!-- /DEPENDENCIES -->

          <!-- FORBIDDEN ZONE-->            
          <nb-card *ngIf="missionParams['FZONE'] && missionForm.value.type == 'FZONE'">
            <nb-card-header class="params-title">Forbidden zone details</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="form-group">
                <label for="reward">Malus when zone is reached</label>
                <input class="form-control" type="number" placeholder="Malus" formControlName="riddleMalus"
                  onwheel="return false;">
              </div>
              <div class="col-3 form-group">
                <nb-toggle status="info" formControlName="canRetry">Zone reactivation (can retry)</nb-toggle>
              </div>
              <div class="form-group" *ngIf="missionForm.value.canRetry">
                <label for="fZoneReactivationSeconds">Zone reactivation delay (seconds)</label>
                <input class="form-control" type="number" formControlName="fZoneReactivationSeconds">
              </div>

              <div class="col-8 form-group">
                <label for="opt-dependencies">Zone deactivation mission dependencies</label>
                <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                  [(ngModel)]="deactivateDeps" [ngModelOptions]="{standalone: true}">
                  <nb-option *ngFor="let mission of _missions" [value]="mission.id">{{ mission.name | txtTranslate }}
                  </nb-option>
                </nb-select>
              </div>

              <div class="col-8 form-group">
                <label for="reward">Zone deactivation object dependencies</label>
                <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                  [(ngModel)]="deactivateObjDeps" [ngModelOptions]="{standalone: true}">
                  <nb-option *ngFor="let object of objects" [value]="object.id">
                    {{ object.labels | txtTranslate }}
                  </nb-option>
                </nb-select>
                <nb-checkbox formControlName="markUsedObjects">Mark objects when used</nb-checkbox>
              </div>

            </nb-card-body>
          </nb-card>

          <!-- REWARD -->
            <nb-card *ngIf="missionParams['REWARD'] && missionForm.value.type == 'REWARD'">
              <nb-card-header class="params-title">Mission Reward</nb-card-header>
              <nb-card-body class="bg-light">
                <div class="form-group">
                  <label for="rewardMode">Reward mode</label>
                  <nb-select formControlName="rewardMode" (selectedChange)="rewardModeChange()">
                    <nb-option value="AUTO">Auto</nb-option>
                    <nb-option value="REACH">Reach location</nb-option>
                    <nb-option value="QRCODE">Scan QR code</nb-option>
                    <nb-option value="PICTURE_PROOF">Picture proof</nb-option>
                    <nb-option value="VIDEO_PROOF">Video proof</nb-option>
                    <!--<nb-option value="ACTOR_RATING">Actor rating</nb-option>-->
                    <nb-option value="RIDDLE">Riddle</nb-option>
                  </nb-select>
                </div>

                <div class="form-group" *ngIf="missionForm.value.rewardMode == 'AUTO' || missionForm.value.rewardMode == 'REACH'">
                  <label for="reward">Reward points</label>
                  <input class="form-control" type="number" placeholder="Reward" formControlName="reward"
                    onwheel="return false;">
                </div>

                <div class="form-group row" *ngIf="missionForm.value.rewardMode == 'AUTO'">
                  <label class="col-12 mb-0" for="riddleAnswerMode">Validation mode</label>
                  <nb-select class="col-12" formControlName="riddleAnswerMode">
                    <nb-option value="MANU">Manual</nb-option>
                    <nb-option value="EXTLINK">External link</nb-option>
                  </nb-select>
                </div>

                <div class="form-group" *ngIf="missionForm.value.rewardMode == 'QRCODE'">
                  <label for="reward">Custom QRCODE</label>
                  <input class="form-control" type="text" placeholder="QR code" formControlName="customQrCode">
                </div>

                <div class="row" *ngIf="missionForm.value.rewardMode == 'RIDDLE'">
                  <div class="col-3 form-group">
                    <nb-toggle status="info" [(ngModel)]="editedMission.customRiddle"
                      [ngModelOptions]="{standalone: true}">Custom riddle?</nb-toggle>
                  </div>
                  <div class="col-3 form-group">
                    <nb-toggle status="info" [(ngModel)]="editedMission.observationRiddle"
                      [ngModelOptions]="{standalone: true}">Observation riddle?</nb-toggle>
                  </div>
                  <div class="col-3 form-group" *ngIf="gameId">
                    <nb-toggle status="info" [(ngModel)]="editedMission.customRiddleProposed"
                      [ngModelOptions]="{standalone: true}">Proposed?</nb-toggle>
                  </div>
                  <div class="col-3 form-group" *ngIf="gameId">
                    <nb-toggle status="info" [(ngModel)]="editedMission.customRiddleVerified"
                      [ngModelOptions]="{standalone: true}">Verified?</nb-toggle>
                  </div>
                </div>
                
                <div class="col-6 form-group">
                  <nb-toggle status="info" formControlName="canRetry">Can be retried</nb-toggle>
                </div>

                <div class="form-group" *ngIf="missionForm.value.rewardMode == 'RIDDLE'">
                  <div class="col-12 form-group">
                    <div class="col-12 bg-white p-3">
                      <h6 class="text-lg font-bold mb-2">Riddle text</h6>
                      <app-block-editor attribute="riddleText" [model]="editedMission?.riddleText"
                        [languages]="languages"
                        [game]="game" [template]="_template" [characters]="characters" 
                        (modelUpdate)="save({riddleText: $event})"></app-block-editor>
                    </div>
                    <!--<richtxt-editor label="Riddle" [model]="editedMission?.riddleText"></richtxt-editor>-->
                  </div>
                  
                  <label>Riddle picture</label>
                  <div class="row">
                    <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                      Please save new mission first
                    </div>
                    <div class="col-3" *ngIf="_mission.id">
                      <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                        [progress]="progressMap['RIDDLEen']" (fileUpdated)="handleFileUpdated($event, 'RIDDLE')"
                        [imageUrl]="_mission.riddleUrl ? _mission.riddleUrl : null"></image-uploader>
                    </div>
                    <div class="col-3 justify-content-end pr-5" *ngIf="_mission.riddleUrl">
                      <button nbButton ghost status="danger" (click)="deleteRiddlePicture(null)">
                        <nb-icon icon="trash"></nb-icon>
                      </button>
                    </div>
                  </div>

                  <label>Language specific picture</label>
                  <div class="row">
                    <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                      Please save new mission first
                    </div>
                    <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                      <div class="col-3" *ngIf="_mission.id">
                        {{ lang }}
                        <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                          [progress]="progressMap['RIDDLELANG'+lang]"
                          (fileUpdated)="handleFileUpdated($event, 'RIDDLELANG', 0, lang)"
                          [imageUrl]="_mission.riddlePic[lang] ? _mission.riddlePic[lang].url : null">
                        </image-uploader>
                        <div class="row justify-content-end pr-5">
                          <button nbButton ghost status="danger" (click)="deleteRiddlePicture(lang)"
                            *ngIf="_mission.riddlePic[lang] && _mission.riddlePic[lang].url">
                            <nb-icon icon="trash"></nb-icon>
                          </button>
                        </div>
                      </div>
                    </ng-template>
                  </div>

                  <label>Riddle audio</label>
                  <div class="row">
                    <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                      Please save new mission first
                    </div>
                    <div class="col-9 form-group" *ngIf="_mission.id">
                      <div class="form-group">
                        <audio-uploader [audioUrl]="editedMission?.riddleAudioUrl"
                          [progress]="progressMap['riddleAudioPath']"
                          (fileUpdated)="audioUpdated($event, 'riddleAudioPath', 'riddleAudioUrl')"
                          (delete)="deleteAudio('riddleAudioPath', 'riddleAudioUrl')"></audio-uploader>
                      </div>
                    </div>
                  </div>

                  <label>Language specific audio</label>
                  <div class="row">
                    <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                      Please save new mission first
                    </div>
                    <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                      <div class="col-3" *ngIf="_mission.id">
                        {{ lang }}
                        <audio-uploader [audioUrl]="_mission.riddleAudio[lang] ? _mission.riddleAudio[lang].url : null"
                          [progress]="progressMap['riddleAudio'+lang]"
                          (fileUpdated)="riddleAudioUpdated($event, lang)"
                          (delete)="deleteRiddleAudio(lang)"></audio-uploader>
                      </div>
                    </ng-template>
                  </div>

                  <div class="row">
                    <div class="col-3 form-group row">
                      <label class="col-12 mb-0" for="riddleAnswerMode">Answer mode</label>
                      <nb-select class="col-12" formControlName="riddleAnswerMode">
                        <nb-option value="FREETXT">Free text</nb-option>
                        <nb-option value="MULTI">Multiple choice</nb-option>
                        <nb-option value="EXTLINK">External link</nb-option>
                      </nb-select>
                    </div>

                    <div class="col-9 form-group pl-5" *ngIf="missionForm.value.riddleAnswerMode == 'FREETXT' && editedMission">
                      <label for="riddleAnswer">Riddle Answer</label>
                      <textarea class="form-control" placeholder="Riddle answer"
                        [(ngModel)]="editedMission.riddleAnswer[languageService.currentLang]"
                        [ngModelOptions]="{standalone: true}"></textarea>
                    </div>

                    <div class="col-9 form-group pl-5" *ngIf="missionForm.value.riddleAnswerMode == 'FREETXT'">
                      <nb-toggle status="info" [(ngModel)]="editedMission.riddleAnswerStrictCheck"
                        [ngModelOptions]="{standalone: true}">Strict check?</nb-toggle>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 form-group">
                      <nb-toggle status="info" formControlName="votingMode">Voting activated</nb-toggle>
                    </div>
                    <div class="col-12 form-group" *ngIf="missionForm.value.riddleAnswerMode == 'MULTI'">
                      <label for="riddleAnswer">Multiple choices</label>
                      <div class="card">
                        <div class="card-block">
                          <h4 class="card-title">{{ riddleAnswers.length }} answers</h4>
                          <div fxLayout="row">
                            <div class="form-group input-group">
                              <input class="form-control" type="text" id="answer" name="answer" [(ngModel)]="newAnswer"
                                [ngModelOptions]="{standalone: true}" placeholder="Answer"
                                (keyup.enter)="addAnswer($event)">
                              <div class="input-group-append">
                                <button type="button" class="btn btn-success" (click)="addAnswer($event)">Add</button>
                              </div>
                            </div>
                          </div>

                          <table class="table" *ngIf="riddleAnswers.length>0">
                            <thead>
                              <tr>
                                <!--<td>Answer</td>-->
                                <td>Answer</td>
                                <td>Picture</td>
                                <td>Correct?</td>
                                <td>Action</td>
                              </tr>
                            </thead>
                            <tbody cdkDropList (cdkDropListDropped)="drop($event,riddleAnswers)">
                              <tr cdkDrag *ngFor="let answer of riddleAnswers; let i = index">
                                <!--<td class="col-1 align-middle">{{ answer.value }}</td>-->
                                <td class="col-auto align-middle">
                                  <input class="form-control w-100" type="text"
                                    [(ngModel)]="answer.labels[languageService.currentLang]"
                                    [ngModelOptions]="{standalone: true}" placeholder="translate here...">
                                </td>
                                <td class="col-3 align-middle">
                                  <div>
                                    <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                                    [progress]="progressMap['RIDDLEMULTI']" (fileUpdated)="handleFileUpdated($event, 'RIDDLEMULTI', i)"
                                    [imageUrl]="answer.pictureUrl"></image-uploader>
                                    <div class="absolute top-0 right-0" *ngIf="answer.pictureUrl">
                                      <button nbButton ghost status="danger" (click)="deleteRiddleMultiPicture(i)"><!---->
                                        <nb-icon icon="trash"></nb-icon>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                                <td class="col-1 align-middle">
                                  <!--{{answer.value}}-->
                                  <nb-checkbox [checked]="answer.correct" (change)="checkAnswer(i)"></nb-checkbox>
                                </td>
                                <td class="col-3 align-middle">
                                  <button nbButton ghost status="danger" (click)="deleteAnswer(i)">
                                    <nb-icon icon="trash"></nb-icon>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!--<div class="col-3 form-group"
                      *ngIf="missionForm.value.riddleAnswerMode == 'FREETXT' || missionForm.value.riddleAnswerMode == 'MULTI'">
                      <nb-toggle status="info" formControlName="autoValidation">Automatic Riddle Validation</nb-toggle>
                    </div>
                    <div class="col-3 form-group" *ngIf="roleGuard.hasOperationalRight()">
                      <nb-toggle status="info" formControlName="isBetMode">Team lays a wager (points)</nb-toggle>
                    </div>-->

                  </div>


                  <div class="form-group row" *ngIf="missionForm.value.isBetMode == false">
                    <div class="col-sm-6">
                      <label for="reward">Points for correct answer</label>
                      <input class="form-control" type="number" formControlName="reward" onwheel="return false;">
                    </div>

                    <div class="col-sm-6">
                      <label for="riddleMalus">Points for wrong answer</label>
                      <input class="form-control" type="number" formControlName="riddleMalus" onwheel="return false;">
                    </div>
                  </div>

                </div>
              </nb-card-body>
            </nb-card>
          <!-- /REWARD -->

          <!--EXTERNAL GAME/URL-->
          <nb-card *ngIf="missionParams['EGL'] && missionForm.value.type == 'REWARD' && (missionForm.value.rewardMode == 'AUTO' || missionForm.value.rewardMode == 'RIDDLE' || missionForm.value.rewardMode == 'REACH')">
            <nb-card-header class="params-title">External game/link</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="form-group">
                <nb-toggle status="info" formControlName="hasExternalLink">External url active</nb-toggle>
              </div>
              <div *ngIf="missionForm.value.hasExternalLink">
                <div class="form-group">
                  <label for="externalUrl">URL</label>
                  <input class="form-control" placeholder="Enter full url here" [(ngModel)]="editedMission.externalUrl"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <div class="form-group">
                  <label class="control-label">Language specific url</label>
                  <multilang-editor [model]="editedMission.externalUrlByLanguage" editMode="true" [htmlMode]="false" [simple]="true"
                    [languages]="languages">
                  </multilang-editor>
                </div>
                <div class="form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.isExternalUrlInline"
                  [ngModelOptions]="{standalone: true}">Inline frame</nb-toggle>
                </div>
                <div class="form-group" *ngIf="editedMission.isExternalUrlInline">
                  <label for="externalUrl">Frame height (defaults to 500px)</label>
                  <input class="form-control" placeholder="" [(ngModel)]="editedMission.externalFrameHeight"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <div class="form-group" *ngIf="!editedMission.isExternalUrlInline">
                  <label class="control-label">Button label</label>
                  <multilang-editor [model]="editedMission?.externalUrlLabel" editMode="true" [htmlMode]="false" [simple]="true"
                    [languages]="languages" [defaultLang]="game?.defaultLang">
                  </multilang-editor>
                </div>
  
                <!--<div class="form-group" *ngIf="missionForm.value.rewardMode == 'AUTO'">
                  <nb-toggle status="info" [(ngModel)]="editedMission.manualValidation"
                    [ngModelOptions]="{standalone: true}">User must validate manually</nb-toggle>
                </div>-->
              </div>
            </nb-card-body>
          </nb-card>

          <!-- CLUES -->            
          <nb-card *ngIf="missionParams['CLUES'] && missionForm.value.type == 'REWARD'">
            <nb-card-header class="params-title">Clues</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="row justify-content-end mb-3 mr-3">
                <button type="button" class="btn btn-success" (click)="addClue($event)">Add</button>
              </div>
              
              <table class="table" *ngIf="riddleClues.length>0">
                <thead>
                  <tr>
                    <td>Text</td>
                    <td>Malus points</td>
                    <td>Malus seconds</td>
                    <td>Change position</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event,riddleClues)">
                  <tr cdkDrag class=" fork-selection" *ngFor="let clue of riddleClues; let i = index" (click)="editClue(clue,i)" [ngClass]="{'selected':currentClueIdx == i}">
                    <td class="col">{{ clue.labels | txtTranslate }}</td>
                    <td class="col-1">
                      <div>{{ clue.riddleClueMalus }}</div>
                    </td>
                    <td class="col-1">
                      <div>{{ clue.riddleClueMalusSeconds }}</div>
                    </td>
                    <td>
                      <button nbButton outline size="tiny" status="info" *ngIf="(riddleClues.length - 1) !== i" (click)="changePosition(i, i+1)">
                        <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
                      </button>
                      <button nbButton size="tiny" status="info" *ngIf="i !== 0" outline (click)="changePosition(i, i-1)">
                        <nb-icon icon="arrow-ios-upward-outline">i</nb-icon>
                      </button>
                    </td>
                    <td class="col-sm-3"><button nbButton ghost status="danger" (click)="deleteClue(i)">
                        <nb-icon icon="trash"></nb-icon>
                      </button></td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="currentClue">
                <h6 class="text-lg font-bold mb-2">Current clue details</h6>
                <app-block-editor [model]="currentClue.labels" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"
                      [game]="game" [template]="_template" [characters]="characters"
                      (modelUpdate)="currentClue.labels = $event; save({riddleClues: riddleClues})"></app-block-editor>
                <!--<div class="form-group">
                  <richtxt-editor label="Label" [model]="currentClue.labels"></richtxt-editor>
                </div>-->
                <div class="row">
                  <div class="col-6 form-group">
                    <label for="cluePoints">Malus points</label>
                    <input class="form-control" type="number" [(ngModel)]="currentClue.riddleClueMalus"
                      [ngModelOptions]="{standalone: true}" onwheel="return false;">
                  </div>
                  <div class="col-6 form-group">
                    <label for="clueSeconds">Malus seconds</label>
                    <input class="form-control" type="number" [(ngModel)]="currentClue.riddleClueMalusSeconds"
                      [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
                <div class="row">
                  <!--IMAGE-->
                  <div class="col-12 form-group" style="text-align:center;" *ngIf="!_mission.id">
                    Please save new mission first
                  </div>
                  <div class="col-12" *ngIf="_mission.id">
                    <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                      [progress]="progressMap['CLUE']" (fileUpdated)="handleFileUpdated($event, 'CLUE')"
                      [imageUrl]="currentClue.pictureUrl"></image-uploader>
                    <div class="row justify-content-end pr-5" *ngIf="currentClue.pictureUrl">
                      <button nbButton ghost status="danger" (click)="deleteCluePicture(null)">
                        <nb-icon icon="trash"></nb-icon>
                      </button>
                    </div>
                  </div>
                </div>
                
                <label>Language specific picture</label>
                <div class="row">
                  <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                    Please save new mission first
                  </div>
                  <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                    <div class="col-3" *ngIf="_mission.id">
                      {{ lang }}
                      <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                        [progress]="progressMap['CLUE'+lang]"
                        (fileUpdated)="handleFileUpdated($event, 'CLUELANG', 0, lang)"
                        [imageUrl]="currentClue.cluePic[lang] ? currentClue.cluePic[lang].url : null">
                      </image-uploader>
                      <div class="row justify-content-end pr-5">
                        <button nbButton ghost status="danger" (click)="deleteCluePicture(lang)"
                          *ngIf="currentClue.cluePic[lang] && currentClue.cluePic[lang].url">
                          <nb-icon icon="trash"></nb-icon>
                        </button>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>

            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="missionParams['FS'] && missionForm.value.type == 'FORK'">
            <nb-card-header class="params-title">Fork details</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="row">
                
                <div class="col-12 bg-white p-3">
                  <h6 class="text-lg font-bold mb-2">Fork text</h6>
                  <app-block-editor attribute="forkText" [model]="editedMission?.forkText"
                    [languages]="languages"
                    [game]="game" [template]="_template" [characters]="characters" 
                    (modelUpdate)="save({forkText: $event})"></app-block-editor>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="reward">Allowed selections</label>
                    <input class="form-control" type="number" formControlName="forkAllowedSelections"
                      onwheel="return false;">
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="votingMode">Voting activated</nb-toggle>
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" formControlName="canRetry">Can be retried</nb-toggle>
                  </div>
                  
                </div>
              </div>

              <label>Fork picture</label>
              <div class="row">
                <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <div class="col-3" *ngIf="_mission.id">
                  <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                    [progress]="progressMap['RIDDLEen']" (fileUpdated)="handleFileUpdated($event, 'RIDDLE')"
                    [imageUrl]="_mission.riddleUrl ? _mission.riddleUrl : null"></image-uploader>
                </div>
                <div class="col-3 justify-content-end pr-5" *ngIf="_mission.riddleUrl">
                  <button nbButton ghost status="danger" (click)="deleteRiddlePicture(null)">
                    <nb-icon icon="trash"></nb-icon>
                  </button>
                </div>
              </div>

              <label>Language specific picture</label>
              <div class="row">
                <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                  <div class="col-3" *ngIf="_mission.id">
                    {{ lang }}
                    <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                      [progress]="progressMap['RIDDLELANG'+lang]"
                      (fileUpdated)="handleFileUpdated($event, 'RIDDLELANG', 0, lang)"
                      [imageUrl]="_mission.riddlePic[lang] ? _mission.riddlePic[lang].url : null">
                    </image-uploader>
                    <div class="row justify-content-end pr-5">
                      <button nbButton ghost status="danger" (click)="deleteRiddlePicture(lang)"
                        *ngIf="_mission.riddlePic[lang] && _mission.riddlePic[lang].url">
                        <nb-icon icon="trash"></nb-icon>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>

              <label>Fork audio</label>
              <div class="row">
                <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <div class="col-9 form-group" *ngIf="_mission.id">
                  <div class="form-group">
                    <audio-uploader [audioUrl]="editedMission?.riddleAudioUrl"
                      [progress]="progressMap['riddleAudioPath']"
                      (fileUpdated)="audioUpdated($event, 'riddleAudioPath', 'riddleAudioUrl')"
                      (delete)="deleteAudio('riddleAudioPath', 'riddleAudioUrl')"></audio-uploader>
                  </div>
                </div>
              </div>

              <label>Language specific audio</label>
              <div class="row">
                <div class="col-3 form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                  <div class="col-3" *ngIf="_mission.id">
                    {{ lang }}
                    <audio-uploader [audioUrl]="_mission.riddleAudio[lang] ? _mission.riddleAudio[lang].url : null"
                      [progress]="progressMap['riddleAudio'+lang]"
                      (fileUpdated)="riddleAudioUpdated($event, lang)"
                      (delete)="deleteRiddleAudio(lang)"></audio-uploader>
                  </div>
                </ng-template>
              </div>

              <div class="row justify-content-between mb-3">
                <h4 class="card-title ml-3">Available selections</h4>
                <button type="button" class="btn btn-success mr-3" (click)="addSelection($event)">Add</button>
              </div>
              <nb-list class="mb-2" *ngIf="forkSelections.length>0" cdkDropList (cdkDropListDropped)="drop($event,forkSelections)">
                <nb-list-item cdkDrag class="fork-selection" *ngFor="let selection of forkSelections; let i = index"
                  (click)="editSelection(selection,i)" [ngClass]="{'selected':currentSelectionIdx == i}">
                  <div class="row w-full">
                    <div class="col-9 max-w-[75%] break-words">
                      {{ selection.labels | txtTranslate }}
                    </div>
                    <div class="col-1 max-w-[8%]">
                      <nb-checkbox [checked]="selection.correct" (change)="checkSelection(i)"></nb-checkbox>
                    </div>
                    <div class="col-1 max-w-[9%]">
                      <div *ngIf="selection.reward">{{ selection.reward }} points</div>
                      <div *ngIf="selection.rewardSeconds">{{ selection.rewardSeconds }} sec</div>
                    </div>
                    <div class="col-1 border-left max-w-[8%]">
                      <button nbButton ghost status="danger" (click)="deleteSelection(i)">
                        <nb-icon icon="trash"></nb-icon>
                      </button>
                    </div>

                  </div>
                </nb-list-item>
              </nb-list>
              <nb-card *ngIf="currentSelection">
                <nb-card-header class="params-title">Current Selection details</nb-card-header>
                <nb-card-body class="bg-light">
                  <div class="row">
                    <div class="col-10 form-group">
                      <richtxt-editor label="Label" [model]="currentSelection.labels"></richtxt-editor>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <label for="reward">Reward points</label>
                        <input nbInput class="form-control" type="number" [(ngModel)]="currentSelection.reward"
                          [ngModelOptions]="{standalone: true}" onwheel="return false;">
                      </div>
                      <div class="form-group">
                        <label for="rewardSeconds">Reward seconds</label>
                        <input nbInput class="form-control" type="number" [(ngModel)]="currentSelection.rewardSeconds"
                          [ngModelOptions]="{standalone: true}" onwheel="return false;">
                      </div>
                    </div>
                  </div>
  
                  <h4>Selection image</h4>
                  <div class="row">
                    <!--IMAGE-->
                    <div class="col-12 form-group" style="text-align:center;" *ngIf="!_mission.id">
                      Please save new mission first
                    </div>
                    <div class="col-12" *ngIf="_mission.id">
                      <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                        [progress]="progressMap['FORK']" (fileUpdated)="handleFileUpdated($event, 'FORK')"
                        [imageUrl]="currentSelection.pictureUrl"></image-uploader>
                      <div class="row justify-content-end pr-5" *ngIf="currentSelection.pictureUrl">
                        <button nbButton ghost status="danger" (click)="deleteForkPicture(null)">
                          <nb-icon icon="trash"></nb-icon>
                        </button>
                      </div>
                    </div>
  
                    <h4>Selection audio</h4>
                    <div class="col-12 form-group" *ngIf="_mission.id">
                      <div class="form-group">
                        <audio-uploader [audioUrl]="currentSelection?.audioUrl"
                          [progress]="progressMap['forkAudio']"
                          (fileUpdated)="forkAudioUpdated($event, null)"
                          (delete)="deleteForkAudio()"></audio-uploader>
                      </div>
                    </div>
                  </div>
  
                  <div class="row">
                    <div class="col-4 form-group">
                      <label for="reward">Selection active only if team has these objects</label>
                      <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                        [(ngModel)]="currentSelection.neededObjects" [ngModelOptions]="{standalone: true}">
                        <nb-option *ngFor="let object of objects" [value]="object.id">
                          {{ object.labels | txtTranslate }}
                        </nb-option>
                      </nb-select>
                      <nb-checkbox name="markUsedObjects" [(ngModel)]="currentSelection.markUsedObjects"
                        [ngModelOptions]="{standalone: true}">Mark objects when used</nb-checkbox>
                    </div>
                    <div class="col-8" *ngIf="game?.hasResources">
                      <div class="form-group">
                        <label for="reward">Selection active only if team has these resources</label>
                        <app-resource-selector [resources]="resources" [resourceQuantities]="currentSelection.neededResources"></app-resource-selector>
                      </div>
                    </div>
                    <div class="col-4 form-group">
                      <label for="reward">Selection will activate misson(s)</label>
                      <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                        [(ngModel)]="currentSelection.activateMissions" [ngModelOptions]="{standalone: true}">
                        <nb-option *ngFor="let mission of _missions" [value]="mission.id">
                          {{ mission.name | txtTranslate }}</nb-option>
                      </nb-select>
                    </div>
                    <div class="col-4 form-group">
                      <label for="reward">Selection will provide object(s)</label>
                      <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                        [(ngModel)]="currentSelection.activateObjects" [ngModelOptions]="{standalone: true}">
                        <nb-option *ngFor="let object of objects" [value]="object.id">
                          {{ object.labels | txtTranslate }}
                        </nb-option>
                      </nb-select>
                    </div>

                    <div class="col-6" *ngIf="game?.hasResources">
                      <div class="form-group">
                        <label for="reward">Selection will provide resource(s)</label>
                        <app-resource-selector [resources]="resources" [resourceQuantities]="currentSelection.selectedResources"></app-resource-selector>
                      </div>
                    </div>
                    <!--<div class="col-6" *ngIf="game?.hasResources">
                      <div class="form-group">
                        <label for="reward">Selection will reduce CO2 impact by</label>
                        <input nbInput class="form-control" type="number" [(ngModel)]="currentSelection.co2Impact"
                          [ngModelOptions]="{standalone: true}" onwheel="return false;">
                      </div>
                    </div>-->
                  </div>
  
                  <div class="row">
                    <div class="col-12 bg-white p-3">
                      <h6 class="text-lg font-bold mb-2">Selected text</h6>
                      <app-block-editor attribute="forkSelectedTxt" [model]="currentSelection.selectedTxt"
                        [languages]="languages"
                        [game]="game" [template]="_template" [characters]="characters" 
                        (modelUpdate)="currentSelection.selectedTxt = $event; save({forkSelections: forkSelections})"></app-block-editor>
                      <!--<richtxt-editor label="Selected text" [model]="currentSelection.selectedTxt"></richtxt-editor>-->
                    </div>
                    <div class="col-12 bg-white p-3">
                      <h6 class="text-lg font-bold mb-2">Unelected text</h6>
                      <app-block-editor attribute="forkUnselectedTxt" [model]="currentSelection.unselectedTxt"
                        [languages]="languages"
                        [game]="game" [template]="_template" [characters]="characters" 
                        (modelUpdate)="currentSelection.unselectedTxt = $event; save({forkSelections: forkSelections})"></app-block-editor>
                      <!--<richtxt-editor label="Unselected text" [model]="currentSelection.unselectedTxt"></richtxt-editor>-->
                    </div>
                  </div>
                </nb-card-body>

              </nb-card>
            </nb-card-body>
          </nb-card>

          <nb-card *ngIf="missionParams['RAQ'] && missionForm.value.type == 'ROLASSIGN'">
            <nb-card-header class="params-title">Role assignment</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="col-3 form-group row">
                <label class="col-12 mb-0" for="assignMode">Assign mode</label>
                <nb-select class="col-12" formControlName="roleAssignMode">
                  <nb-option value="AUTO">Automatic</nb-option>
                  <nb-option value="QUIZZ">Quizz</nb-option>
                </nb-select>
              </div>
              <div *ngIf="missionForm.value.roleAssignMode=='QUIZZ'">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <richtxt-editor label="Quizz text" [model]="editedMission?.quizzText"></richtxt-editor>
                    </div>
                  </div>
                </div>

                <div class="row justify-content-between mb-3">
                  <h4 class="card-title ml-3">Add new</h4>
                  <button type="button" class="btn btn-success mr-3" (click)="addQuizzQuestion($event)">Add</button>
                </div>
                <nb-list class="mb-2" *ngIf="quizzQuestions.length>0" cdkDropList (cdkDropListDropped)="drop($event,quizzQuestions)">
                  <nb-list-item cdkDrag class="fork-selection" *ngFor="let selection of quizzQuestions; let i = index"
                    (click)="editSelection(selection,i)" [ngClass]="{'selected':currentSelectionIdx == i}">
                    <div class="row w-full">
                      <div class="col-8 max-w-[75%] break-words">
                        {{ selection.labels | txtTranslate }}
                      </div>
                      <div class="col-3">
                        {{ getRole(selection.roleId)?.labels | txtTranslate}}
                      </div>
                      <div class="col-1 border-left max-w-[8%]">
                        <button nbButton ghost status="danger" (click)="deleteQuizzQuestion(i)">
                          <nb-icon icon="trash"></nb-icon>
                        </button>
                      </div>

                    </div>
                  </nb-list-item>
                </nb-list>
                <nb-card *ngIf="currentSelection">
                  <nb-card-header class="params-title">Current Selection details</nb-card-header>
                  <nb-card-body class="bg-light">
                    <div class="row">
                      <div class="col-12 form-group">
                        <richtxt-editor label="Label" [model]="currentSelection.labels"></richtxt-editor>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="reward">Selection will assign role</label>
                          <nb-select fullWidth filled status="primary" placeholder="Select role"
                            [(ngModel)]="currentSelection.roleId" [ngModelOptions]="{standalone: true}">
                            <nb-option *ngFor="let role of roles" [value]="role.id">
                              {{ role.labels | txtTranslate }}</nb-option>
                          </nb-select>
                        </div>
                      </div>
                    </div>
    
                    <h4>Selection image</h4>
                    <div class="row">
                      <!--IMAGE-->
                      <div class="col-12 form-group" style="text-align:center;" *ngIf="!_mission.id">
                        Please save new mission first
                      </div>
                      <div class="col-12" *ngIf="_mission.id">
                        <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                          [progress]="progressMap['RAQUIZZ']" (fileUpdated)="handleFileUpdated($event, 'RAQUIZZ')"
                          [imageUrl]="currentSelection.pictureUrl"></image-uploader>
                        <div class="row justify-content-end pr-5" *ngIf="currentSelection.pictureUrl">
                          <button nbButton ghost status="danger" (click)="deleteForkPicture(null)">
                            <nb-icon icon="trash"></nb-icon>
                          </button>
                        </div>
                      </div>
    
                      <h4>Selection audio</h4>
                      <div class="col-12 form-group" *ngIf="_mission.id">
                        <div class="form-group">
                          <audio-uploader [audioUrl]="currentSelection?.audioUrl"
                            [progress]="progressMap['quizzAudio']"
                            (fileUpdated)="raQuizzAudioUpdated($event, null)"
                            (delete)="deleteRaQuizzAudio()"></audio-uploader>
                        </div>
                      </div>
                    </div>
    
                    <div class="row">
                      <div class="col-4 form-group">
                        <label for="reward">Selection will provide object(s) to the player</label>
                        <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                          [(ngModel)]="currentSelection.activateObjects" [ngModelOptions]="{standalone: true}">
                          <nb-option *ngFor="let object of objects" [value]="object.id">
                            {{ object.labels | txtTranslate }}
                          </nb-option>
                        </nb-select>
                      </div>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </nb-card-body>
          </nb-card>

          <nb-card *ngIf="missionParams['RRV'] && missionForm.value.type == 'ROLREVEAL'">
            <nb-card-header class="params-title">Role reveal</nb-card-header>
            <nb-card-body class="bg-light">
              <div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <richtxt-editor label="Quizz text" [model]="editedMission?.quizzText"></richtxt-editor>
                    </div>
                  </div>
                </div>

                <div class="row justify-content-between mb-3">
                  <h4 class="card-title ml-3">Add new</h4>
                  <button type="button" class="btn btn-success mr-3" (click)="addQuizzQuestion($event)">Add</button>
                </div>
                <nb-list class="mb-2" *ngIf="quizzQuestions.length>0" cdkDropList (cdkDropListDropped)="drop($event,quizzQuestions)">
                  <nb-list-item cdkDrag class="fork-selection" *ngFor="let selection of quizzQuestions; let i = index"
                    (click)="editSelection(selection,i)" [ngClass]="{'selected':currentSelectionIdx == i}">
                    <div class="row w-full">
                      <div class="col-8 max-w-[75%] break-words">
                        {{ selection.labels | txtTranslate }}
                      </div>
                      <div class="col-3">
                        {{ getRole(selection.roleId)?.labels | txtTranslate}}
                      </div>
                      <div class="col-1 border-left max-w-[8%]">
                        <button nbButton ghost status="danger" (click)="deleteQuizzQuestion(i)">
                          <nb-icon icon="trash"></nb-icon>
                        </button>
                      </div>

                    </div>
                  </nb-list-item>
                </nb-list>
                <nb-card *ngIf="currentSelection">
                  <nb-card-header class="params-title">Current Selection details</nb-card-header>
                  <nb-card-body class="bg-light">
                    <div class="row">
                      <div class="col-12 form-group">
                        <richtxt-editor label="Label" [model]="currentSelection.labels"></richtxt-editor>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="reward">Role to reveal</label>
                          <nb-select fullWidth filled status="primary" placeholder="Select role"
                            [(ngModel)]="currentSelection.roleId" [ngModelOptions]="{standalone: true}">
                            <nb-option *ngFor="let role of roles" [value]="role.id">
                              {{ role.labels | txtTranslate }}</nb-option>
                          </nb-select>
                        </div>
                      </div>
                    </div>
    
                    <h4>Selection image</h4>
                    <div class="row">
                      <!--IMAGE-->
                      <div class="col-12 form-group" style="text-align:center;" *ngIf="!_mission.id">
                        Please save new mission first
                      </div>
                      <div class="col-12" *ngIf="_mission.id">
                        <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                          [progress]="progressMap['RAQUIZZ']" (fileUpdated)="handleFileUpdated($event, 'RAQUIZZ')"
                          [imageUrl]="currentSelection.pictureUrl"></image-uploader>
                        <div class="row justify-content-end pr-5" *ngIf="currentSelection.pictureUrl">
                          <button nbButton ghost status="danger" (click)="deleteForkPicture(null)">
                            <nb-icon icon="trash"></nb-icon>
                          </button>
                        </div>
                      </div>
    
                      <h4>Selection audio</h4>
                      <div class="col-12 form-group" *ngIf="_mission.id">
                        <div class="form-group">
                          <audio-uploader [audioUrl]="currentSelection?.audioUrl"
                            [progress]="progressMap['quizzAudio']"
                            (fileUpdated)="raQuizzAudioUpdated($event, null)"
                            (delete)="deleteRaQuizzAudio()"></audio-uploader>
                        </div>
                      </div>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </nb-card-body>
          </nb-card>

          <nb-card *ngIf="missionParams['QUIZZ'] && missionForm.value.type == 'QUIZZ'">
            <nb-card-header class="params-title">Quizz</nb-card-header>
            <nb-card-body class="bg-light">
              <app-quizz [questions]="quizzList" [resources]="resources" [game]="game" [languages]="languages"
                [defaultLang]="game?.defaultLang"></app-quizz>
            </nb-card-body>
          </nb-card>

          <nb-card *ngIf="missionParams['SUCCESS'] && missionForm.value.type !== 'POI'">
            <nb-card-header class="params-title">Success</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="row">
                <div class="col-12">
                  <div class="col-12 border border-cgray-900 p-3">
                    <h2 class="text-lg font-bold mb-2">Success message</h2>
                    <app-block-editor attribute="successMessage" [model]="editedMission?.successMessage"
                      [languages]="languages"
                      [game]="game" [template]="_template" [characters]="characters" 
                      (modelUpdate)="save({successMessage: $event})"></app-block-editor>
                  </div>
                </div>
                <div class="col-6" >
                  <div class="form-group">
                    <div for="reward">Success will activate misson(s)</div>
                    <app-dropdown [multiple]="true" [elements]="_missions" [selected]="successMissions" (selectElement)="selectSuccessMissions($event)"></app-dropdown>
                  </div>
                  <div class="form-group">
                    <nb-toggle status="info" [(ngModel)]="editedMission.successDispatch" [ngModelOptions]="{standalone: true}">Dispatch mode</nb-toggle>
                  </div>
                </div>
                <div class="col-6" *ngIf="!openMission"><!-- && game?.hasResources-->
                  <div class="form-group">
                    <label for="reward">Success will provide object(s)</label>
                    <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                      [(selected)]="successObjects">
                      <nb-option *ngFor="let object of objects" [value]="object.id">
                        {{ object.labels | txtTranslate }}
                      </nb-option>
                    </nb-select>
                  </div>
                </div>
                <div class="col-6" *ngIf="game?.hasResources">
                  <div class="form-group">
                    <label for="reward">Success will provide resource(s)</label>
                    <app-resource-selector [resources]="resources" [resourceQuantities]="editedMission.successResources"></app-resource-selector>
                  </div>
                </div>
              </div>

              <div class="row border-bottom mb-5 pb-5">
                <div class="col-12">
                  <div class="form-group">
                    <label for="name">Success audio</label>
                    <audio-uploader [audioUrl]="editedMission?.successAudioUrl"
                      [progress]="progressMap['successAudioPath']"
                      (fileUpdated)="audioUpdated($event, 'successAudioPath', 'successAudioUrl')"
                      (delete)="deleteAudio('successAudioPath', 'successAudioUrl')"></audio-uploader>
                  </div>
                </div>
                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.successAudioAutoplay" [ngModelOptions]="{standalone: true}">Autoplay active</nb-toggle>
                </div>

                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.successAudioLoop" [ngModelOptions]="{standalone: true}">Loop active</nb-toggle>
                </div>
              </div>

              <div class="form-group">
                <label>Select a success picture or use drag/drop</label>
                <div class="form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <div *ngIf="_mission.id">
                  <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                    [progress]="progressMap['SUCCESSen']" (fileUpdated)="handleFileUpdated($event, 'SUCCESS')"
                    [imageUrl]="_mission.successPictureUrl" style="margin:10px;"></image-uploader>
                  <div class="row justify-content-end pr-5">
                    <button nbButton ghost status="danger" (click)="deleteSuccessPicture()"
                      *ngIf="_mission.successPictureUrl">
                      <nb-icon icon="trash"></nb-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="missionForm.value.successPopup == true && editedMission">
                <label>Success popup button text</label>
                <input id="successbtn" class="form-control" placeholder="Success button text"
                  [(ngModel)]="editedMission.successAction[languageService.currentLang]"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="form-group" *ngIf="missionForm.value.successPopup == true">
                <div class="form-group">
                  <nb-toggle status="info" formControlName="successGotoNext">Go to next mission automatically
                  </nb-toggle>
                </div>
              </div>

            </nb-card-body>
          </nb-card>

          <nb-card *ngIf="missionParams['FAILED'] && (missionForm.value.type == 'REWARD' || missionForm.value.type == 'FZONE')">
            <nb-card-header class="params-title">Failed</nb-card-header>
            <nb-card-body class="bg-light">   
              <div class="row">
                <div class="col-12 bg-white p-3">
                  <h6 class="text-lg font-bold mb-2">Fail message</h6>
                  <app-block-editor attribute="failMessage" [model]="editedMission?.failMessage"
                    [languages]="languages"
                    [game]="game" [template]="_template" [characters]="characters" 
                    (modelUpdate)="save({failMessage: $event})"></app-block-editor>
                </div>
                <!--<div class="form-group">
                  <richtxt-editor label="Fail message" [model]="editedMission?.failMessage"></richtxt-editor>
                </div>-->
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" >
                    <div for="reward">Failure will activate misson(s)</div>
                    <app-dropdown [multiple]="true" [elements]="_missions" [selected]="editedMission.failMissions" (selectElement)="selectFailedMissions($event)"></app-dropdown>
                  </div>
                  <div class="form-group">
                    <div class="form-group">
                      <nb-toggle status="info" formControlName="failPopup">Show fail popup</nb-toggle>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="missionForm.value.failPopup == true && editedMission">
                    <label>Fail popup title</label>
                    <input id="failtitle" class="form-control" placeholder="Success title"
                      [(ngModel)]="editedMission.failTitle[languageService.currentLang]"
                      [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>

              <div class="col-sm-12" *ngIf="missionForm.value.canRetry">
                <h4>Fail messages in case of 'can retry' mission</h4>
                <div class="row justify-content-end mb-3 mr-3">
                  <button type="button" class="btn btn-success" (click)="addFailMessage()">Add</button>
                </div>

                <div class="form-group row justify-content-between"
                  *ngFor="let message of editedMission.failMessageList; let i = index">
                  <div class="col-10">
                    <h6 class="text-lg font-bold mb-2">Message {{ i }}</h6>
                    <app-block-editor [model]="message"
                        [languages]="languages" [defaultLang]="game?.defaultLang"
                        [game]="game" [template]="_template" [characters]="characters"
                        (modelUpdate)="editedMission.failMessageList[i] = $event; save({failMessageList: editedMission.failMessageList})"></app-block-editor>
                    <!--<richtxt-editor class="col-10" label="Message {{ i }}" [model]="message"></richtxt-editor>-->
                  </div>
                  <button class="col-2" nbButton ghost status="danger" (click)="deleteFailMessage(i)">
                    <nb-icon icon="trash"></nb-icon>
                  </button>
                </div>
              </div>


              <div class=" col-sm-12 form-group">
                <label>Select a fail picture or use drag/drop</label>
                <div class="form-group" style="text-align:center;" *ngIf="!_mission.id">
                  Please save new mission first
                </div>
                <div *ngIf="_mission.id">
                  <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                    [progress]="progressMap['FAILen']" (fileUpdated)="handleFileUpdated($event, 'FAIL')"
                    [imageUrl]="_mission.failPictureUrl" style="margin:10px;"></image-uploader>
                  <div class="row justify-content-end pr-5">
                    <button nbButton ghost status="danger" (click)="deleteFailPicture()"
                      *ngIf="_mission.failPictureUrl">
                      <nb-icon icon="trash"></nb-icon>
                    </button>
                  </div>
                </div>
              </div>

              <div class="row border-bottom mb-5 pb-5">
                <div class="col-12">
                  <div class="form-group">
                    <label for="name">Fail audio</label>
                    <audio-uploader [audioUrl]="editedMission?.failAudioUrl"
                      [progress]="progressMap['successAudioPath']"
                      (fileUpdated)="audioUpdated($event, 'failAudioPath', 'failAudioUrl')"
                      (delete)="deleteAudio('failAudioPath', 'failAudioUrl')"></audio-uploader>
                  </div>
                </div>
                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.failAudioAutoplay" [ngModelOptions]="{standalone: true}">Autoplay active</nb-toggle>
                </div>

                <div class="col-6 form-group">
                  <nb-toggle status="info" [(ngModel)]="editedMission.failAudioLoop" [ngModelOptions]="{standalone: true}">Loop active</nb-toggle>
                </div>
              </div>

              <div class="col-sm-12 form-group" *ngIf="missionForm.value.failPopup == true && editedMission">
                <label>Fail popup button text</label>
                <input id="failbtn" class="form-control" placeholder="Fail button text"
                  [(ngModel)]="editedMission.failAction[languageService.currentLang]"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="col-sm-12 form-group" *ngIf="missionForm.value.failPopup == true">
                <div class="form-group">
                  <nb-toggle status="info" formControlName="failGotoNext">Go to next mission automatically</nb-toggle>
                </div>
              </div>       

            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="missionParams['MSP'] && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'">
            <nb-card-header class="params-title">Mission specific parameters</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="form-group">
                <nb-toggle status="info" [(ngModel)]="editedMission.specificActivationTime" [ngModelOptions]="{standalone: true}">Specific activation time</nb-toggle>
              </div>
              <div class="form-group" *ngIf="editedMission.specificActivationTime">
                <label for="specificActivationTime">Activated after: (Number of minutes after timer has started)</label>
                <input class="form-control" type="number" [(ngModel)]="editedMission.activationMinutesAfterStart" [ngModelOptions]="{standalone: true}" onwheel="return false;">
              </div>
              <div class="form-group">
                <nb-toggle status="info" formControlName="timeLimited">Time limited mission</nb-toggle>
              </div>
              <!--<div class="form-group">
                <nb-toggle status="info" formControlName="timeLimitedManual">Manual activation/deactivation</nb-toggle>
              </div>-->
              <div class="form-group" *ngIf="missionForm.value.timeLimited && !missionForm.value.timeLimitedManual">
                <label for="timeLimitedSeconds">Duration (seconds)</label>
                <input class="form-control" type="number" formControlName="timeLimitedSeconds" onwheel="return false;">
              </div>
              <div class="form-group">
                <nb-toggle status="info" formControlName="isProgressStep">Mission is a progress step</nb-toggle>
              </div>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="!gameId && missionParams['B2B'] && roleGuard.hasOperationalRight() && missionForm.value.type !== 'POI'">
            <nb-card-header class="params-title">B2B parameters</nb-card-header>
            <nb-card-body class="bg-light">
              <div class="form-group"
                  *ngIf="missionForm.value.type == 'REWARD' && (missionForm.value.rewardMode == 'PICTURE_PROOF' || missionForm.value.rewardMode == 'RIDDLE' || missionForm.value.rewardMode == 'VIDEO_PROOF')">
                <nb-toggle status="info" formControlName="scoredByAdmin">Mission is scored by admin</nb-toggle>
              </div>
              <!--<div class="form-group">
                <nb-toggle status="info" formControlName="timeLimitedManual">Manual activation/deactivation</nb-toggle>
              </div>-->
              <div class="form-group">
                <nb-toggle status="info" formControlName="groupCustomMeetingPoint">Group custom meeting point</nb-toggle>
              </div>
              <!--<div class="form-group" *ngIf="missionForm.value.timeLimited && !missionForm.value.timeLimitedManual">
                <label for="timeLimitedSeconds">Duration (seconds)</label>
                <input class="form-control" type="number" formControlName="timeLimitedSeconds" onwheel="return false;">
              </div>-->
            </nb-card-body>
          </nb-card>
      </div>
    </div>
  </form>
  <div *ngIf="openMission" class="pr-4 pt-2 pb-12">
      <button nbButton size="medium" ghost class="float-left btn" status="danger" (click)="deleteMission($event, editedMission)">
        <nb-icon icon="trash"></nb-icon>
      </button>
      <button nbButton size="medium" class="float-right btn ml-3" status="success" (click)="onSubmit()" >save</button>
      <button nbButton size="medium" status="danger" class="float-right" (click)="close()" >cancel</button>
  </div>
</div>